"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoctorSubstitutesHttpService = void 0;
const types_1 = require("../../types");
const add_doctor_substitute_contract_1 = require("../../types/doctor-substitutes/add-doctor-substitute-contract");
const delete_doctor_subtitute_1 = require("../../types/doctor-substitutes/delete-doctor-subtitute");
const delete_doctor_subtitute_contract_1 = require("../../types/doctor-substitutes/delete-doctor-subtitute-contract");
const get_doctor_substitute_contract_details_1 = require("../../types/doctor-substitutes/get-doctor-substitute-contract-details");
const get_doctor_substitute_contracts_list_1 = require("../../types/doctor-substitutes/get-doctor-substitute-contracts-list");
const get_doctor_substitute_list_1 = require("../../types/doctor-substitutes/get-doctor-substitute-list");
const get_doctor_substitute_with_invitations_list_1 = require("../../types/doctor-substitutes/get-doctor-substitute-with-invitations-list");
const update_doctor_subtitute_1 = require("../../types/doctor-substitutes/update-doctor-subtitute");
const http_service_1 = require("../http.service");
class DoctorSubstitutesHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/doctor-substitutes`);
    }
    getDetails(params) {
        return this.getEntity(params.id, {
            schema: types_1.getDoctorSubstituteApiResponseSchema,
        });
    }
    getList(payload) {
        const params = {
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        if (payload.filter) {
            params.filter = payload.filter;
        }
        if (payload.officeId) {
            params.officeId = payload.officeId;
        }
        if (payload.officeAccessType) {
            params.officeAccessType = payload.officeAccessType;
        }
        if (payload.date) {
            params.date = payload.date;
        }
        if (payload.period) {
            params.period = payload.period;
        }
        if (payload.includeDeleted) {
            params.includeDeleted = 'true';
        }
        return this.getEntityList('', {
            params,
            schema: get_doctor_substitute_list_1.getDoctorSubstitutesListApiResponseSchema,
        });
    }
    getListWithInvitations(payload) {
        const params = {
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        if (payload.officeId) {
            params.officeId = payload.officeId;
        }
        if (payload.search) {
            params.search = payload.search;
        }
        if (payload.priority) {
            params.priority = payload.priority;
        }
        return this.getEntityList('with-invitations', {
            params,
            schema: get_doctor_substitute_with_invitations_list_1.getDoctorSubstitutesWithInvitationsListApiResponseSchema,
        });
    }
    update(id, payload) {
        return this.putEntity(`${id}`, {
            body: payload,
            schema: update_doctor_subtitute_1.updateDoctorSubstituteApiResponseSchema,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    /**
     * Uploads a supporting document (licence de remplacement or attestation
     * RCP), replacing the previous one.
     */
    replaceDocument(params, payload) {
        return this.put(`${encodeURIComponent(params.id)}/documents/${encodeURIComponent(params.type)}`, {
            body: payload,
            schema: types_1.replaceDoctorSubstituteDocumentApiResponseSchema,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    /** Fetches a short-lived URL to view a supporting document. */
    getDocumentUrl(params) {
        return this.get(`${encodeURIComponent(params.id)}/documents/${encodeURIComponent(params.type)}`, { schema: types_1.getDoctorSubstituteDocumentUrlApiResponseSchema });
    }
    deleteById(id) {
        return this.delete(id, {
            schema: delete_doctor_subtitute_1.deleteDoctorSubstituteApiResponseSchema,
        });
    }
    addContract(id, payload) {
        return this.postEntity(`${id}/contracts`, {
            body: payload,
            schema: add_doctor_substitute_contract_1.addDoctorSubstituteContractApiResponseSchema,
        });
    }
    getExistsContract(id, payload) {
        const params = {
            from: payload.from,
            to: payload.to,
            doctorAttendingId: payload.doctorAttendingId,
        };
        if (payload.retrocessionRate !== undefined) {
            params.retrocessionRate = String(payload.retrocessionRate);
        }
        return this.get(`${id}/contracts/exists`, {
            params,
            schema: types_1.getDoctorSubstituteContractExistsResponseSchema,
        });
    }
    getContractPreview(id, payload) {
        return this.get(`${id}/contracts/preview`, {
            params: payload,
            schema: types_1.previewDoctorSubstituteContractsResponseSchema,
        });
    }
    signContract(doctorSubstituteId, contractId) {
        return this.postEntity(`${doctorSubstituteId}/contracts/${contractId}/sign`, {
            schema: add_doctor_substitute_contract_1.addDoctorSubstituteContractApiResponseSchema,
        });
    }
    getContractDetailsById(doctorSubstituteId, contractId) {
        return this.getEntity(`${doctorSubstituteId}/contracts/${contractId}`, {
            schema: get_doctor_substitute_contract_details_1.getDoctorSubstituteContractDetailsApiResponseSchema,
        });
    }
    getMyAvailability(payload) {
        return this.get('me/availability', {
            params: payload,
            schema: types_1.getSubstituteAvailabilityApiResponseSchema,
        });
    }
    syncMyAvailability(payload) {
        return this.put('me/availability', {
            body: payload,
            schema: types_1.syncSubstituteAvailabilityApiResponseSchema,
        });
    }
    getPhysicalOfficeAccessList(doctorSubstituteId) {
        return this.get(`${doctorSubstituteId}/physical-office-access`, { schema: types_1.getSubstitutePhysicalOfficeAccessResponseSchema });
    }
    grantPhysicalOfficeAccess(doctorSubstituteId, officeId, siteId) {
        return this.put(`${doctorSubstituteId}/physical-office-access/${officeId}/${siteId}`, { body: {} });
    }
    revokePhysicalOfficeAccess(doctorSubstituteId, officeId, siteId) {
        return this.delete(`${doctorSubstituteId}/physical-office-access/${officeId}/${siteId}`);
    }
    deleteContractById(doctorSubstituteId, contractId) {
        return this.delete(`${doctorSubstituteId}/contracts/${contractId}`, {
            schema: delete_doctor_subtitute_contract_1.deleteDoctorSubstituteContractApiResponseSchema,
        });
    }
    getContractList(id, payload) {
        const params = {
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        if (payload.officeId) {
            params.officeId = payload.officeId;
        }
        if (payload.search) {
            params.search = payload.search;
        }
        if (payload.period) {
            params.period = JSON.stringify(payload.period);
        }
        if (payload.signatureStatus && payload.signatureStatus !== 'all') {
            params.signatureStatus = payload.signatureStatus;
        }
        return this.getEntityList(`${id}/contracts/list`, {
            params,
            schema: get_doctor_substitute_contracts_list_1.getDoctorSubstituteContractsListApiResponseSchema,
        });
    }
}
exports.DoctorSubstitutesHttpService = DoctorSubstitutesHttpService;
